import React from 'react';
import format from 'date-fns/format';
import { ptBR } from 'date-fns/locale';
import isFuture from 'date-fns/isFuture';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { MdArrowBackIosNew, MdArrowForwardIos } from 'react-icons/md';

import * as S from './styles';

type DatePickerHeaderProps = {
  initialDate?: Date;
} & ReactDatePickerCustomHeaderProps;

const DatePickerHeader = (props: DatePickerHeaderProps) => {
  const [enableDecreaseMonthButton, setEnableDecreaseMonthButton] = React.useState(false);
  React.useEffect(() => {
    const currentDate = new Date();
    if (props.monthDate.getFullYear() === currentDate.getFullYear()) {
      if (props.monthDate.getMonth() === currentDate.getMonth()) setEnableDecreaseMonthButton(false);
      else setEnableDecreaseMonthButton(true);
    } else setEnableDecreaseMonthButton(true);
  }, [props.monthDate]);

  const enableArroPreviousMonth = isFuture(props.monthDate);

  return (
    <S.Container>
      {enableDecreaseMonthButton && !!enableArroPreviousMonth ? (
        <button onClick={props.decreaseMonth}>
          <MdArrowBackIosNew size={50} />
        </button>
      ) : (
        <button />
      )}
      <h5>
        {format(props.monthDate, 'MMM YYY', {
          locale: ptBR
        })}
      </h5>
      <button onClick={props.increaseMonth}>
        <MdArrowForwardIos />
      </button>
    </S.Container>
  );
};

export default DatePickerHeader;
